/*

  GataDagsins-Right-Side.ts

  Right-side component for Gáta Dagsins with scores and comparisons

  Copyright (C) 2025 Miðeind ehf.
  Author: Vilhjálmur Þorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { Component, m } from "./mithril";
import { IPlayerMove, IView } from "./types";
import { MobileStatus } from "./mobile-status";
import { RightSideTabs } from "./rightsidetabs";

interface IAttributes {
  view: IView;
  selectedMoves: IPlayerMove[]; // Moves selected by the player
  bestMove: IPlayerMove | undefined; // The top-scoring word, if played by any player
  onStatsClick: () => void; // Handler to open stats modal
}

export const GataDagsinsRightSide: Component<IAttributes> = {
  // Component containing both mobile status bar and desktop tabbed view
  view: (vnode) => {
    const { view, selectedMoves, bestMove, onStatsClick } = vnode.attrs;
    const { riddle } = view.model;

    const onMoveClick = (word: string, coord: string) => {
      if (riddle && word && coord) {
        // Recreate the word on the board
        riddle.recreateWordOnBoard(word, coord);
      }
    };

    return m(".gatadagsins-right-side-wrapper",
      riddle ? [
        // Mobile-only status bar (visible on mobile, hidden on desktop)
        m(".gatadagsins-mobile-status", m(MobileStatus, {
          view,
          selectedMoves,
          bestMove,
          onMoveClick,
          onStatsClick,
        })),
        // Desktop-only tabbed view (hidden on mobile, visible on desktop)
        m(".gatadagsins-thermometer-column", m(RightSideTabs, {
          view,
          selectedMoves,
          bestMove,
          onMoveClick,
        })),
      ] : null
    );
  }
};
